import { Injectable } from '@angular/core';
import { createFrom, EventService, LoginEvent } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { Ga4GgUserLoginEvent } from './ga4-gg-user-login.event';

@Injectable({
  providedIn: 'root',
})
export class Ga4GgUserLoginEventBuilder {
  constructor(private eventService: EventService) {
    const ga4GgUserLoginEventSource = this.eventService.get(LoginEvent).pipe(
      map(() =>
        createFrom(Ga4GgUserLoginEvent, {
          event: 'login',
        })
      )
    );

    eventService.register(Ga4GgUserLoginEvent, ga4GgUserLoginEventSource);
  }
}
